declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export const initGA = () => {
  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

  if (!measurementId) {
    console.warn("Missing required Google Analytics key: VITE_GA_MEASUREMENT_ID");
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // Google Analytics expects each queued command to be an Arguments object.
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false });

  const script1 = document.createElement("script");
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script1);
};

export const trackPageView = (url: string) => {
  if (typeof window === "undefined" || !window.gtag) return;

  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (!measurementId) return;

  // Initialization disables automatic page views. Send the public-route event
  // explicitly; another config call retains send_page_view:false.
  window.gtag("event", "page_view", {
    send_to: measurementId,
    page_path: url,
  });
};

export const trackEvent = (action: string, category?: string, label?: string, value?: number) => {
  if (typeof window === "undefined" || !window.gtag) return;

  window.gtag("event", action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};
